import React from "react";

import MultiSelectFilter from "components/filters/MultiSelectFilter";
import { useAppSelector } from "store";
import { chooseAllBrandPositions, deselectAllBrandPositions, selectBrandPositions, toggleBrandPositionIsSelected } from "modules/customer/tools/location/retailers/retailersSlice";


const BrandPositionsDropdown: React.FC = () => {
    const brandPositions = useAppSelector(selectBrandPositions);
    return (
        <MultiSelectFilter
            title="Brand Positioning"
            items={brandPositions}
            chooseAllItems={chooseAllBrandPositions}
            deselectAllItems={deselectAllBrandPositions}
            toggleItemIsSelected={toggleBrandPositionIsSelected}
        />
    );
};

export default BrandPositionsDropdown;
